import script from "./InstructionGPlusPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionGPlusPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionGPlusPage.vue?vue&type=style&index=0&id=efb4d9ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb4d9ac"]])

export default __exports__